import WarningCircleIcon from 'components/icons/WarningCircleIcon';

type FormErrorProps = {
  error: string;
  id?: string;
};

const FormError = ({ error, id }: FormErrorProps) => {
  return (
    <div className="form-error" id={id ? id : 'error'} role="alert">
      <WarningCircleIcon size="small" color="red" /> {error}
    </div>
  );
};

export default FormError;
